import {Card, Empty, Pagination, Spin} from 'antd';
import {useEffect, useState} from 'react';

import {Locale} from '../../../../../../provider/locale/locale';
import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {AI_MONITORING_ANSWERS_PAGE_SIZE} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-const';
import {useAiMonitoringAnswers} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-hook';

import {AnswerCard} from './answer-card';
import * as styles from './answers-feed.scss';

type PropsType = {
    brandId: number;
    runId: string | null;
};

export function AnswersFeed(props: PropsType): JSX.Element {
    const {brandId, runId} = props;
    const {getLocalizedString} = useLocale();
    const [page, setPage] = useState(1);

    // Reset to the first page whenever the run changes, so we never request a page that the
    // new run may not have.
    useEffect(() => {
        setPage(1);
    }, [runId]);

    const {data, isLoading} = useAiMonitoringAnswers(brandId, {
        runId: runId ?? undefined, // eslint-disable-line no-undefined
        page,
        pageSize: AI_MONITORING_ANSWERS_PAGE_SIZE,
    });

    const answers = data?.results ?? [];
    const total = data?.count ?? 0;

    if (isLoading && answers.length === 0) {
        return (
            <Card size="small" title={<Locale stringKey="AI_BRAND_MONITORING__ANSWERS__TITLE" />}>
                <Spin />
            </Card>
        );
    }

    if (answers.length === 0) {
        return (
            <Card size="small" title={<Locale stringKey="AI_BRAND_MONITORING__ANSWERS__TITLE" />}>
                <Empty description={getLocalizedString('AI_BRAND_MONITORING__ANSWERS__NO_ANSWERS')} />
            </Card>
        );
    }

    return (
        <Card size="small" title={<Locale stringKey="AI_BRAND_MONITORING__ANSWERS__TITLE" />}>
            {answers.map((answer) => (
                <AnswerCard answer={answer} key={answer.id} />
            ))}
            <div className={styles.answers_feed__pagination}>
                <Pagination
                    current={page}
                    onChange={setPage}
                    pageSize={AI_MONITORING_ANSWERS_PAGE_SIZE}
                    showSizeChanger={false}
                    total={total}
                />
            </div>
        </Card>
    );
}
